export const environment = {
  production: false,
  portalUrl: 'https://test-portal.linqsandbox.com',
  apiUrl: 'https://dev.services.linq.com/payments',
  redirectUri: 'https://dev.merchants.pay.linq.com',
};
